var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{style:({border:'none',width:'100%',height:_vm.height+'px'}),attrs:{"name":"pdf-box","id":_vm.boxId,"src":_vm.src,"border":"none"}})
}
var staticRenderFns = []

export { render, staticRenderFns }